import { replacePlaceholders } from '@/core/utils/installation'

import type { BuildImportCodeParams } from '../interfaces'

import { computeGcgNames, toGcgPlaceholders } from './computeGcgNames'

export const buildImportCode = ({
  selectedTechnology,
  technologyImports,
  technologyLibraryImports,
  libraryData,
  classData,
  packageManager,
}: BuildImportCodeParams): string => {
  if (!selectedTechnology) return ''

  const template = classData
    ? (technologyImports[selectedTechnology] ?? '')
    : (technologyLibraryImports[selectedTechnology] ?? '')
  if (!template) return ''

  const names = computeGcgNames({ selectedTechnology, libraryData })

  return replacePlaceholders(template, {
    ...toGcgPlaceholders(names),
    packageManager,
    library: libraryData?.name ?? 'unknown-library',
    class: classData?.name ?? 'unknown-class',
  })
}
